var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSyncProblem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12C3 14.21 3.91 16.2 5.36 17.64L3 20H9V14L6.76 16.24C5.68 15.15 5 13.66 5 12C5 9.39 6.67 7.17 9 6.35V4.26C5.55 5.15 3 8.27 3 12ZM11 17H13V15H11V17ZM21 4H15V10L17.24 7.76C18.32 8.85 19 10.34 19 12C19 14.61 17.33 16.83 15 17.65V19.74C18.45 18.85 21 15.73 21 12C21 9.79 20.09 7.8 18.64 6.36L21 4ZM11 13H13V7H11V13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncProblem);
export default __webpack_public_path__ + "static/media/syncProblem.e17491a0c8d7963fb30a86e2d6268813.svg";
export { ForwardRef as ReactComponent };